import { observer } from 'mobx-react-lite'
import { StartNewServiceConfirmationDialog } from './index'
import type { ServiceSelectionViewModel } from '@/features/dashboard/DashboardView/ServiceSelectionViewModel'

export interface StartNewServiceConfirmationDialogContainerProps {
  vm: ServiceSelectionViewModel
}

export const StartNewServiceConfirmationDialogContainer = observer(
  function StartNewServiceConfirmationDialogContainer({
    vm,
  }: StartNewServiceConfirmationDialogContainerProps) {
    const testId = 'start-new-service-confirmation-dialog'

    return (
      <StartNewServiceConfirmationDialog
        isOpen={vm.startNewServiceConfirmationModalVm.showing}
        onClose={vm.startNewServiceConfirmationModalVm.close}
        onGoToExistingJob={vm.goToExistingJob}
        onContinueAnyway={vm.continueAnyway}
        testId={testId}
        goToExistingJobTestId={`${testId}-go-to-existing-job-button`}
        continueAnywayTestId={`${testId}-continue-anyway-button`}
      />
    )
  },
)
